<template>

    <voffice-popup-box :trigger-id="triggerId"
        class="full-xxs"
        :apply-label="applyLabel"
        @closed="onClosed">

        <table class="guestbox">

            <tr v-for="(l,what) in sections"
                class="gb-row">

                <td class="gb-td label">
                    <label>{{getFieldLabel(what)}}</label>
                    <div class="age"
                        v-if="what === 'adults'">{{voMsg('tpl.adults.age')}}</div>
                    <div class="age"
                        v-if="what === 'children'">{{voMsg('tpl.children.age')}}</div>
                    <div class="age"
                        v-if="what === 'babys'">{{voMsg('tpl.baby.age')}}</div>

                </td>
                <td class="gb-td">

                    <button class="btn btn-default"
                        :aria-label="labelMinus()"
                        :disabled="!canDecr(what)"
                        @click="inc(what,-1)"
                        type="button"><i class="fa-sharp fa-light fa-circle-minus icon"></i></button>
                </td>
                <td class="gb-td">

                    <button class="btn btn-default"
                        aria-label="labelPlus()"
                        :disabled="!canInc(what)"
                        @click="inc(what,1)"
                        type="button"><i class="fa-sharp fa-light fa-circle-plus icon"></i></button>
                </td>
            </tr>

            <tr v-if="maxbel">
                <td colspan="3"
                    class="max-bel">
                    <div class="alert alert-danger">
                        {{voMsg('tpl.text.maxOccupancyReached')}}
                    </div>

                </td>

            </tr>

        </table>

    </voffice-popup-box>

</template>

<script>
    import vofficePopupBox from './PopupBox.vue';
    import V from 'voUtils/V.js'

    export default {
    	voVueComponent: 'voffice-guestbox',
    	components: {
    		vofficePopupBox
    	},
    	voMsgCodes: [
    		'pet.pl',
    		'adult.pl',
    		'child.pl',
    		'baby.pl',
    	],
    	props: {
    		maxValues: Object,
    		minValues: Object,
    		searchData: Object,
    		showDogCountInSearch: Boolean,
    		triggerId: String,
    		applyLabel: String,
    		childrenWelcome: Boolean,
    		babiesWelcome: Boolean,
    		petsWelcome: Boolean,
    		beds: [Number, String],
    		bedsForKids: [Number, String]
    	},
    	data: function() {
    		return {
    			maxbel: false
    		};
    	},
    	computed: {
    		sections: function() {
    			var res = {
    				'adults': 'adult'
    			};
    			if (VOFFICE.settings.childrenAges && this.childrenWelcome) {
    				Object.assign(res, {
    					'children': 'child',
    				});
    			} else if (this.childrenWelcome) {
    				Object.assign(res, {
    					'children': 'child',
    				});
    			}
    			/*if (this.babiesWelcome) {
    				Object.assign(res, {
    					'babys': 'baby'
    				});
    			}*/
    			if (this.petsWelcome) {
    				res.petsCount = 'pet';
    			}

    			return res;

    		}
    	},
    	methods: {
    		labelMinus: function() {
    			return this.voMsg('tpl.text.minus');
    		},
    		labePlus: function() {
    			return this.voMsg('tpl.text.plus');
    		},
    		onClosed: function() {
    			this.$emit('closed');
    		},

    		getFieldLabel: function(what) {
    			var amount = this.searchData[what] || 0;
    			return amount + ' ' + this.voMsgPl(this.sections[what] + '.pl', amount);
    		},
    		inc: function(what, step) {
    			this.searchData[what] = ((this.searchData[what] || 0) - 0) + step;
    			if (what == 'petsCount') {
    				this.searchData.pets = this.searchData[what] > 0;
    			}

    		},
    		checkPersons: function(what) {

    			if (parseInt(this.searchData['adults']) + parseInt(this.searchData['children']) >= this.beds) {
    				this.maxbel = true;
    				return false;
    			} else {
    				this.maxbel = false;
    				return true;
    			}
    		},
    		canInc: function(what) {
    			var amount = ((this.searchData[what] || 0) - 0);
    			var max = this.maxValues && this.maxValues[what];
    			if (max != undefined && amount >= max) {
    				return false;
    			}
    			if (VOFFICE.settings.check4MaxBeds) {
    				if (what === 'adults' || what === 'children') {
    					if (this.beds && parseInt(this.beds) > 0) {
    						return this.checkPersons(what);
    					}
    				}
    			}
    			return true;
    		},
    		canDecr: function(what) {
    			var amount = ((this.searchData[what] || 0) - 0);
    			var min = this.minValues && this.minValues[what];
    			if (min == undefined) {
    				min = what == 'adults' ? 1 : 0
    			}

    			if (min != undefined && amount <= min) {
    				return false;
    			}
    			return true;
    		},

    	}

    };
</script>

<style scoped>
    .guestbox {
    	margin: 0 auto;
    	line-height: 46px;
    	text-align: left;
    	font-size: 15px;
    	color: #676767;
    }


    .gb-td {
    	padding: 8px 12px;
    }

    .gb-td.label {
    	line-height: 1;
    }

    .age {
    	font-size: 14px;
    	padding-top: 5px;
    }

    .alert-danger {
    	line-height: 20px;
    }

    .icon {
    	position: unset !important;
    	font-size: 40px !important;
    	opacity: 1 !important;
    }


    .btn {
    	width: 48px;
    	height: 48px;
    	line-height: 1;
    	border: none;
    	font-size: 40px;
    	padding: 4px;
    	color: #a7a4a4;
    }

    .btn:hover {
    	background-color: transparent;
    	color: var(--color-primary);
    }

    .btn:focus {
    	background-color: transparent;
    	color: var(--color-primary);
    }


    .btn.disabled,
    .btn:disabled {
    	color: #bbb9b9;
    }

    .label {
    	white-space: nowrap;
    }

    @media (max-width:768px) {}
</style>